const signatureStatus = Object.freeze({
  Signed: 1,
  UnSigned: 2
});

export const SignatureStatus = signatureStatus;
